/**
 * Truncates a string with an elipsis
 * @param  {string}  string String to be shortened with an ellipses at the end if its too long
 * @param  {number}  length Number of characters to allow before truncation
 */
export const truncateString = (string, length) => {
    if (string.length > length) {
        return `${string.slice(0, length)}...`;
    }

    return string;
};
